import styled from "styled-components";

import { lingoAdDimensionStyles } from "icons/IconGridWithAds/styles";

export const SkeletonSquarespaceAdContainer = styled.div``;

export const SkeletonLingoAdContainer = styled.div`
    ${lingoAdDimensionStyles}
`;
